(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["blog-article-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blog-article-cards-slider')) {
    customElements.define(
      'blog-article-cards-slider',
      class BlogArticleCardsSlider extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.track = this.querySelector('[data-blog-article-cards-track]');
          this.previous = this.querySelector('[data-blog-article-cards-prev]');
          this.next = this.querySelector('[data-blog-article-cards-next]');
          this.progress = this.querySelector('[data-blog-article-cards-progress]');
          this.onResize = () => this.update();

          this.previous?.addEventListener('click', () => this.scrollByCard(-1));
          this.next?.addEventListener('click', () => this.scrollByCard(1));
          this.track?.addEventListener('scroll', () => this.update(), { passive: true });
          window.addEventListener('resize', this.onResize);

          if (this.track) {
            this.resizeObserver = new ResizeObserver(this.onResize);
            this.resizeObserver.observe(this.track);
          }

          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.onResize);
          this.resizeObserver?.disconnect();
        }

        scrollByCard(direction) {
          if (!this.track) return;

          const firstCard = this.track.querySelector('.blog-article-cards__card');
          const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
          const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;

          this.track.scrollBy({
            left: distance * direction,
            behavior: 'smooth',
          });
        }

        update() {
          if (!this.track) return;

          const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
          const hasOverflow = maxScroll > 1;
          const scrollRatio = hasOverflow ? this.track.scrollLeft / maxScroll : 0;
          const thumbRatio =
            this.track.scrollWidth > 0 ? Math.min(this.track.clientWidth / this.track.scrollWidth, 1) : 1;
          const thumbWidth = Math.max(thumbRatio * 100, 14);
          const travel = Math.max(100 - thumbWidth, 0);

          if (this.previous) this.previous.disabled = !hasOverflow || this.track.scrollLeft <= 1;
          if (this.next) this.next.disabled = !hasOverflow || this.track.scrollLeft >= maxScroll - 1;

          if (this.progress) {
            this.progress.style.width = `${thumbWidth}%`;
            this.progress.style.left = `${scrollRatio * travel}%`;
            this.progress.style.transform = 'none';
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class BluuSubscriptionInfo extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-subscription-info-trigger]');
      this.panel = this.querySelector('[data-subscription-info-panel]');

      if (!this.trigger || !this.panel) return;

      this.trigger.addEventListener('click', this.handleToggle);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('click', this.handleDocumentClick);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.handleToggle);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('click', this.handleDocumentClick);
    }

    handleToggle = () => {
      if (!this.trigger || !this.panel) return;

      const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
      this.setOpen(!isOpen);
    };

    handleDocumentClick = (event) => {
      if (event.target instanceof Node && !this.contains(event.target)) {
        this.setOpen(false);
      }
    };

    handleKeydown = (event) => {
      if (event.key !== 'Escape') return;

      event.preventDefault();
      this.setOpen(false);
      this.trigger?.focus();
    };

    setOpen(isOpen) {
      if (!this.trigger || !this.panel) return;

      this.trigger.setAttribute('aria-expanded', String(isOpen));
      this.panel.hidden = !isOpen;
    }
  }

  if (!customElements.get('bluu-subscription-info')) {
    customElements.define('bluu-subscription-info', BluuSubscriptionInfo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["curved-text"] && !Shopify.designMode) return;
  try {
    class CurvedText extends HTMLElement {
    connectedCallback() {
      this.svg = this.querySelector('.curved-text__svg');
      this.path = this.querySelector('[data-curved-text-path]');
      this.copy = this.querySelector('[data-curved-text-copy]');
      this.textPath = this.querySelector('[data-curved-text-text-path]');

      if (!this.svg || !this.path || !this.copy || !this.textPath) return;

      this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      this.tabletMediaQuery = window.matchMedia('(min-width: 750px) and (max-width: 1024px)');
      this.updateCurve = this.updateCurve.bind(this);
      this.resizeObserver = new ResizeObserver(this.updateCurve);
      this.resizeObserver.observe(this);
      this.mobileMediaQuery.addEventListener('change', this.updateCurve);
      this.tabletMediaQuery.addEventListener('change', this.updateCurve);
      this.updateCurve();

      if (document.fonts?.ready) {
        document.fonts.ready.then(() => {
          if (this.isConnected) this.updateCurve();
        });
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mobileMediaQuery?.removeEventListener('change', this.updateCurve);
      this.tabletMediaQuery?.removeEventListener('change', this.updateCurve);
    }

    updateCurve() {
      const width = this.svg.clientWidth;
      const height = this.svg.clientHeight;

      if (!width || !height) return;

      const suffix = this.mobileMediaQuery.matches
        ? 'Mobile'
        : this.tabletMediaQuery.matches
          ? 'Tablet'
          : '';
      const angle = this.numberValue(`curveAngle${suffix}`, 30, 0, 120);
      const direction = this.dataset[`curveDirection${suffix}`];
      const position = this.numberValue(`horizontalPosition${suffix}`, 0, -40, 40);
      const alignment = this.dataset[`alignment${suffix}`];
      const fontSize = Number.parseFloat(window.getComputedStyle(this.copy).fontSize) || 32;
      const pathPadding = Math.max(fontSize * 0.65, width * 0.03);
      const chord = Math.max(width - pathPadding * 2, 1);
      const angleInRadians = (angle * Math.PI) / 720;
      const requestedSagitta = (chord / 2) * Math.tan(angleInRadians);
      const maximumSagitta = Math.max(height - fontSize * 1.1, 0);
      const sagitta = Math.min(requestedSagitta, maximumSagitta);
      const contentHeight = sagitta + fontSize * 1.1;
      const top = Math.max((height - contentHeight) / 2, 0);
      const curvesUp = direction !== 'down';
      const baseline = curvesUp ? top + fontSize * 0.9 + sagitta : top + fontSize * 0.9;
      const controlY = baseline + (curvesUp ? -2 : 2) * sagitta;
      const startX = pathPadding;
      const endX = width - pathPadding;
      const centerX = width / 2;
      const anchor = alignment === 'right' ? 'end' : alignment === 'left' ? 'start' : 'middle';
      const alignmentOffset = alignment === 'right' ? 100 : alignment === 'left' ? 0 : 50;
      const startOffset = Math.max(-40, Math.min(140, alignmentOffset + position));

      this.svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
      this.style.setProperty('--curved-text-empty-bottom', `${top}px`);
      this.path.setAttribute(
        'd',
        `M ${startX} ${baseline} Q ${centerX} ${controlY} ${endX} ${baseline}`
      );
      this.copy.setAttribute('text-anchor', anchor);
      this.textPath.setAttribute('startOffset', `${startOffset}%`);
    }

    numberValue(name, fallback, minimum, maximum) {
      const value = Number(this.dataset[name]);
      if (!Number.isFinite(value)) return fallback;
      return Math.max(minimum, Math.min(maximum, value));
    }
  }

  if (!customElements.get('curved-text')) {
    customElements.define('curved-text', CurvedText);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-complementary-products"] && !Shopify.designMode) return;
  try {
    class CustomComplementaryProducts extends HTMLElement {
    connectedCallback() {
      this.eventTarget = this.closest('.shopify-section, dialog');
      this.eventTarget?.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      this.eventTarget?.removeEventListener('shopify:product:select', this.handleProductSelect);
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const replacement = Array.from(
            detail.html.querySelectorAll('custom-complementary-products[data-custom-complementary-products]')
          ).find((element) => element.dataset.blockId === this.dataset.blockId);

          if (!replacement) return;

          this.replaceWith(replacement.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') {
            console.warn('[custom-complementary-products] Event promise rejected:', error);
          }
        });
    };
  }

  if (!customElements.get('custom-complementary-products')) {
    customElements.define('custom-complementary-products', CustomComplementaryProducts);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["drop-callout-3"] && !Shopify.designMode) return;
  try {
    class DropCallout3 extends HTMLElement {
    connectedCallback() {
      this.referenceText = this.normalizeText(this.dataset.textWidthReference || '');
      this.svg = this.querySelector('[data-drop-callout-3-text-svg]');
      if (!this.referenceText || !this.svg) return;

      this.context = document.createElement('canvas').getContext('2d');
      if (!this.context) return;

      this.scheduleUpdate = () => {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.updateTextPosition());
      };
      this.textObserver = new MutationObserver(this.scheduleUpdate);
      this.textObserver.observe(this.svg, { childList: true, characterData: true, subtree: true });
      this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
      this.resizeObserver.observe(this);
      document.fonts?.addEventListener('loadingdone', this.scheduleUpdate);
      document.fonts?.ready.then(() => {
        if (this.isConnected) this.scheduleUpdate();
      });
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      this.textObserver?.disconnect();
      this.resizeObserver?.disconnect();
      document.fonts?.removeEventListener('loadingdone', this.scheduleUpdate);
      cancelAnimationFrame(this.updateFrame);
    }

    normalizeText(text) {
      return text.replace(/\s+/g, ' ').trim();
    }

    updateTextPosition() {
      this.svg.querySelectorAll('textPath[data-normal-offset]').forEach((textPath) => {
        const style = getComputedStyle(textPath.parentElement);
        this.context.font = `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        const text = this.normalizeText(textPath.textContent);
        const referenceWidth = this.context.measureText(this.referenceText).width;
        const textWidth = this.context.measureText(text).width;
        const isLonger = textWidth > referenceWidth + 0.5;
        const offset = isLonger ? textPath.dataset.longOffset : textPath.dataset.normalOffset;
        const value = `${offset}%`;
        if (textPath.getAttribute('startOffset') !== value) textPath.setAttribute('startOffset', value);
      });
    }
  }

  if (!customElements.get('drop-callout-3')) {
    customElements.define('drop-callout-3', DropCallout3);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-helpcenter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faq-helpcenter')) {
    customElements.define(
      'faq-helpcenter',
      class FaqHelpcenter extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.categories = Array.from(this.querySelectorAll('[data-helpcenter-category]'));
          this.closeSiblings = this.dataset.closeSiblings === 'true';
          this.openFirst = this.dataset.openFirst === 'true';
          this.detailsTransitionCleanups = new WeakMap();
          this.handleTopicClick = (event) => this.onTopicClick(event);
          this.handleSummaryClick = (event) => this.onSummaryClick(event);
          this.handleHashChange = () => this.applyHashRoute({ shouldScroll: true });

          this.querySelectorAll('[data-helpcenter-topic]').forEach((topic) => {
            topic.addEventListener('click', this.handleTopicClick);
          });

          this.querySelectorAll('[data-faq-number]').forEach((details) => {
            details.classList.toggle('faq-helpcenter__item--expanded', details.open);
            details.querySelector('.faq-helpcenter__summary')?.addEventListener('click', this.handleSummaryClick);
          });

          window.addEventListener('hashchange', this.handleHashChange);
          this.applyHashRoute({ shouldScroll: window.location.hash.startsWith('#faq-') });
        }

        disconnectedCallback() {
          this.querySelectorAll('[data-helpcenter-topic]').forEach((topic) => {
            topic.removeEventListener('click', this.handleTopicClick);
          });

          this.querySelectorAll('[data-faq-number]').forEach((details) => {
            this.cancelDetailsTransition(details);
            details.querySelector('.faq-helpcenter__summary')?.removeEventListener('click', this.handleSummaryClick);
          });

          window.removeEventListener('hashchange', this.handleHashChange);
          this.initialized = false;
        }

        normalizeHandle(value) {
          let decodedValue = String(value || '');

          try {
            decodedValue = decodeURIComponent(decodedValue);
          } catch (_error) {
            // Keep the original fragment when it contains malformed URI characters.
          }

          return decodedValue
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/ß/g, 'ss')
            .replace(/&/g, '-')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        }

        parseHashRoute() {
          const rawHash = window.location.hash.replace(/^#/, '');
          let categoryPart = rawHash;
          let topic = '';
          let question = '';

          if (rawHash.includes('?')) {
            const queryIndex = rawHash.indexOf('?');
            categoryPart = rawHash.slice(0, queryIndex);
            const parameters = new URLSearchParams(rawHash.slice(queryIndex + 1));
            topic = parameters.get('topic') || '';
            question = parameters.get('frage') || parameters.get('question') || parameters.get('faq') || '';
          } else if (rawHash.includes('&')) {
            const legacyParts = rawHash.split('&');
            categoryPart = legacyParts[0] || '';
            topic = legacyParts[1] || '';
            question = legacyParts[2] || '';
          }

          return {
            category: this.normalizeHandle(categoryPart.replace(/^faq-/, '')),
            topic: this.normalizeHandle(topic),
            question: String(question || '').trim(),
          };
        }

        applyHashRoute({ shouldScroll = false } = {}) {
          if (!this.categories.length) return;

          const route = this.parseHashRoute();
          const category =
            this.categories.find((candidate) => candidate.dataset.helpcenterCategory === route.category) ||
            this.categories[0];

          this.selectCategory(category);

          let matchingQuestion = null;

          if (route.question) {
            matchingQuestion = Array.from(category.querySelectorAll('[data-faq-number]')).find(
              (details) => String(details.dataset.faqNumber) === route.question
            );
          }

          const questionPanel = matchingQuestion?.closest('[data-helpcenter-topic-panel]');
          const requestedTopic = questionPanel?.dataset.helpcenterTopicPanel || route.topic;
          const activeTopicPanel = this.selectTopic(category, requestedTopic);

          if (matchingQuestion) {
            activeTopicPanel?.querySelectorAll('[data-faq-number][open]').forEach((details) => {
              if (details !== matchingQuestion) this.setDetailsOpen(details, false, { animate: false });
            });
            this.setDetailsOpen(matchingQuestion, true, { animate: false });
          }

          window.requestAnimationFrame(() => {
            if (!shouldScroll) return;

            const scrollTarget = matchingQuestion || this;
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            scrollTarget.scrollIntoView({
              behavior: reducedMotion ? 'auto' : 'smooth',
              block: 'start',
            });

            if (matchingQuestion) {
              matchingQuestion.querySelector('summary')?.focus({ preventScroll: true });
            }
          });
        }

        selectCategory(activeCategory) {
          this.categories.forEach((category) => {
            category.hidden = category !== activeCategory;
          });
        }

        selectTopic(category, topicHandle) {
          const tabs = Array.from(category.querySelectorAll('[data-helpcenter-topic]'));
          const panels = Array.from(category.querySelectorAll('[data-helpcenter-topic-panel]'));
          const selectedTab = tabs.find((tab) => tab.dataset.helpcenterTopic === topicHandle) || tabs[0];

          if (!selectedTab) return null;

          tabs.forEach((tab) => {
            tab.setAttribute('aria-selected', String(tab === selectedTab));
          });

          let activePanel = null;
          panels.forEach((panel) => {
            const isActive = panel.dataset.helpcenterTopicPanel === selectedTab.dataset.helpcenterTopic;
            panel.hidden = !isActive;
            if (isActive) activePanel = panel;
          });

          if (this.openFirst && activePanel && !activePanel.querySelector('[data-faq-number][open]')) {
            const firstQuestion = activePanel.querySelector('[data-faq-number]');
            if (firstQuestion) this.setDetailsOpen(firstQuestion, true, { animate: false });
          }

          return activePanel;
        }

        onTopicClick(event) {
          const topic = event.currentTarget;
          const category = topic.closest('[data-helpcenter-category]');
          if (!category) return;

          this.selectTopic(category, topic.dataset.helpcenterTopic);
          this.updateHash(category.dataset.helpcenterCategory, topic.dataset.helpcenterTopic);
        }

        onSummaryClick(event) {
          event.preventDefault();

          const activeDetails = event.currentTarget.closest('[data-faq-number]');
          if (!activeDetails) return;

          const shouldOpen = !activeDetails.classList.contains('faq-helpcenter__item--expanded');
          const topicPanel = activeDetails.closest('[data-helpcenter-topic-panel]');
          const category = activeDetails.closest('[data-helpcenter-category]');

          if (shouldOpen && this.closeSiblings) {
            topicPanel?.querySelectorAll('.faq-helpcenter__item--expanded').forEach((details) => {
              if (details !== activeDetails) this.setDetailsOpen(details, false);
            });
          }

          this.setDetailsOpen(activeDetails, shouldOpen);

          if (shouldOpen && category && topicPanel) {
            this.updateHash(
              category.dataset.helpcenterCategory,
              topicPanel.dataset.helpcenterTopicPanel,
              activeDetails.dataset.faqNumber
            );
          }
        }

        setDetailsOpen(details, shouldOpen, { animate = true } = {}) {
          const answerClip = details.querySelector('.faq-helpcenter__answer-clip');
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.cancelDetailsTransition(details);

          if (!animate || reduceMotion || !answerClip) {
            details.classList.toggle('faq-helpcenter__item--expanded', shouldOpen);
            details.open = shouldOpen;
            return;
          }

          if (shouldOpen) {
            if (!details.open) {
              details.open = true;
              answerClip.getBoundingClientRect();
            }

            details.classList.add('faq-helpcenter__item--expanded');
            return;
          }

          if (!details.open) {
            details.classList.remove('faq-helpcenter__item--expanded');
            return;
          }

          details.classList.remove('faq-helpcenter__item--expanded');

          let transitionFinished = false;
          let fallbackTimer;

          const finishTransition = () => {
            if (transitionFinished) return;

            transitionFinished = true;
            answerClip.removeEventListener('transitionend', handleTransitionEnd);
            window.clearTimeout(fallbackTimer);

            if (!details.classList.contains('faq-helpcenter__item--expanded')) {
              details.open = false;
            }

            this.detailsTransitionCleanups.delete(details);
          };

          const handleTransitionEnd = (transitionEvent) => {
            if (transitionEvent.target === answerClip && transitionEvent.propertyName === 'grid-template-rows') {
              finishTransition();
            }
          };

          answerClip.addEventListener('transitionend', handleTransitionEnd);
          fallbackTimer = window.setTimeout(finishTransition, 750);
          this.detailsTransitionCleanups.set(details, finishTransition);
        }

        cancelDetailsTransition(details) {
          const cleanup = this.detailsTransitionCleanups?.get(details);
          if (cleanup) cleanup();
        }

        updateHash(category, topic, question = '') {
          const parameters = new URLSearchParams();
          if (topic) parameters.set('topic', topic);
          if (question) parameters.set('frage', question);

          const query = parameters.toString();
          const nextHash = `#faq-${encodeURIComponent(category)}${query ? `?${query}` : ''}`;
          window.history.replaceState(null, '', nextHash);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faq-block')) {
    customElements.define(
      'faq-block',
      class FaqBlock extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.tabs = Array.from(this.querySelectorAll('[data-faq-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-faq-panel]'));
          this.closeSiblings = this.dataset.closeSiblings === 'true';
          this.openFirst = this.dataset.openFirst === 'true';
          this.isProductContext = this.dataset.productContext === 'true';
          this.detailsTransitionCleanups = new WeakMap();
          this.handleTabClick = (event) => this.selectTab(event.currentTarget.dataset.faqTab);
          this.handleSummaryClick = (event) => this.onSummaryClick(event);
          this.handleProductSelect = (event) => this.updateFromProductSelect(event);

          this.tabs.forEach((tab) => tab.addEventListener('click', this.handleTabClick));
          this.querySelectorAll('.faq-block__item').forEach((details) => {
            details.classList.toggle('faq-block__item--expanded', details.open);
            details.querySelector('.faq-block__summary')?.addEventListener('click', this.handleSummaryClick);
          });

          this.updateNavigationLayout();

          if (this.isProductContext) {
            document.addEventListener('shopify:product:select', this.handleProductSelect);
            this.updateVariant(this.dataset.currentVariantId);
          }
        }

        disconnectedCallback() {
          this.tabs?.forEach((tab) => tab.removeEventListener('click', this.handleTabClick));
          this.querySelectorAll('.faq-block__item').forEach((details) => {
            this.cancelDetailsTransition(details);
            details.querySelector('.faq-block__summary')?.removeEventListener('click', this.handleSummaryClick);
          });
          document.removeEventListener('shopify:product:select', this.handleProductSelect);
          this.initialized = false;
        }

        updateNavigationLayout() {
          const visibleTabs = this.tabs.filter((tab) => !tab.hidden);
          this.classList.toggle('faq-block--single-category', visibleTabs.length === 1);
        }

        selectTab(tabName) {
          if (!tabName) return;

          this.tabs.forEach((tab) => {
            const isSelected = !tab.hidden && tab.dataset.faqTab === tabName;
            tab.setAttribute('aria-selected', String(isSelected));
          });

          this.panels.forEach((panel) => {
            const isActive = panel.dataset.faqPanel === tabName;
            panel.hidden = !isActive;
            panel.classList.toggle('faq-block__panel--active', isActive);
          });
        }

        onSummaryClick(event) {
          event.preventDefault();

          const activeDetails = event.currentTarget.closest('.faq-block__item');
          if (!activeDetails) return;

          const shouldOpen = !activeDetails.classList.contains('faq-block__item--expanded');
          const panel = activeDetails.closest('[data-faq-panel]');

          if (shouldOpen && this.closeSiblings) {
            panel?.querySelectorAll('.faq-block__item--expanded').forEach((details) => {
              if (details !== activeDetails) this.setDetailsOpen(details, false);
            });
          }

          this.setDetailsOpen(activeDetails, shouldOpen);
        }

        setDetailsOpen(details, shouldOpen, { animate = true } = {}) {
          const answerClip = details.querySelector('.faq-block__answer-clip');
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.cancelDetailsTransition(details);

          if (!animate || reduceMotion || !answerClip) {
            details.classList.toggle('faq-block__item--expanded', shouldOpen);
            details.open = shouldOpen;
            return;
          }

          if (shouldOpen) {
            if (!details.open) {
              details.open = true;
              answerClip.getBoundingClientRect();
            }

            details.classList.add('faq-block__item--expanded');
            return;
          }

          if (!details.open) {
            details.classList.remove('faq-block__item--expanded');
            return;
          }

          details.classList.remove('faq-block__item--expanded');

          let transitionFinished = false;
          let fallbackTimer;

          const finishTransition = () => {
            if (transitionFinished) return;

            transitionFinished = true;
            answerClip.removeEventListener('transitionend', handleTransitionEnd);
            window.clearTimeout(fallbackTimer);

            if (!details.classList.contains('faq-block__item--expanded')) {
              details.open = false;
            }

            this.detailsTransitionCleanups.delete(details);
          };

          const handleTransitionEnd = (transitionEvent) => {
            if (transitionEvent.target === answerClip && transitionEvent.propertyName === 'grid-template-rows') {
              finishTransition();
            }
          };

          answerClip.addEventListener('transitionend', handleTransitionEnd);
          fallbackTimer = window.setTimeout(finishTransition, 750);
          this.detailsTransitionCleanups.set(details, finishTransition);
        }

        cancelDetailsTransition(details) {
          const cleanup = this.detailsTransitionCleanups?.get(details);
          if (cleanup) cleanup();
        }

        updateFromProductSelect(event) {
          if (!(event.target instanceof Element)) return;
          if (event.target.closest('product-card, quick-add-dialog')) return;
          if (!event.promise) return;

          event.promise
            .then(({ detail }) => {
              if (!this.isConnected || !detail) return;
              if (String(detail.productId) !== String(this.dataset.productId)) return;

              this.updateVariant(detail.resource?.id);
            })
            .catch(() => {});
        }

        updateVariant(variantId) {
          const normalizedVariantId = String(variantId ?? '');

          this.panels.forEach((panel) => {
            const items = Array.from(panel.querySelectorAll('.faq-block__item'));

            items.forEach((item) => {
              const isAlwaysVisible = item.dataset.faqPlacement === 'always';
              const variantIds = (item.dataset.faqVariantIds || '')
                .split(',')
                .map((id) => id.trim())
                .filter(Boolean);
              const isVisible = isAlwaysVisible || variantIds.includes(normalizedVariantId);

              item.hidden = !isVisible;
              if (!isVisible) this.setDetailsOpen(item, false, { animate: false });
            });

            const hasVisibleItems = items.some((item) => !item.hidden);
            const tab = this.tabs.find((candidate) => candidate.dataset.faqTab === panel.dataset.faqPanel);

            if (tab) tab.hidden = !hasVisibleItems;

            if (this.openFirst && hasVisibleItems && !items.some((item) => !item.hidden && item.open)) {
              const firstVisibleItem = items.find((item) => !item.hidden);
              if (firstVisibleItem) this.setDetailsOpen(firstVisibleItem, true, { animate: false });
            }
          });

          const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true' && !tab.hidden);
          const firstVisibleTab = this.tabs.find((tab) => !tab.hidden);

          this.updateNavigationLayout();

          if (selectedTab) {
            this.selectTab(selectedTab.dataset.faqTab);
          } else if (firstVisibleTab) {
            this.selectTab(firstVisibleTab.dataset.faqTab);
          } else {
            this.tabs.forEach((tab) => tab.setAttribute('aria-selected', 'false'));
            this.panels.forEach((panel) => {
              panel.hidden = true;
              panel.classList.remove('faq-block__panel--active');
            });
          }

          this.hidden = !firstVisibleTab;
          this.dataset.currentVariantId = normalizedVariantId;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["footer-dropdowns"] && !Shopify.designMode) return;
  try {
    class FooterDropdownsComponent extends HTMLElement {
    connectedCallback() {
      this.localization = this.querySelector('.footer-dropdowns__localization');
      this.localizationSummary = this.querySelector('.footer-dropdowns__localization > .footer-dropdowns__summary');
      this.payments = this.querySelector('.footer-dropdowns__payments');
      this.paymentSummary = this.querySelector('.footer-dropdowns__payments > .footer-dropdowns__summary');

      this.localization?.addEventListener('toggle', this.handleLocalizationToggle);
      this.payments?.addEventListener('toggle', this.handlePaymentsToggle);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('pointerdown', this.handlePointerDown);
    }

    disconnectedCallback() {
      this.localization?.removeEventListener('toggle', this.handleLocalizationToggle);
      this.payments?.removeEventListener('toggle', this.handlePaymentsToggle);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('pointerdown', this.handlePointerDown);
    }

    handleLocalizationToggle = () => {
      if (this.localization?.open && this.payments) this.payments.open = false;
    };

    handlePaymentsToggle = () => {
      if (this.payments?.open && this.localization) this.localization.open = false;
    };

    handleKeydown = (event) => {
      if (event.key !== 'Escape') return;

      if (this.localization?.open) {
        this.localization.open = false;
        this.localizationSummary?.focus();
        event.stopPropagation();
        return;
      }

      if (!this.payments?.open) return;

      this.payments.open = false;
      this.paymentSummary?.focus();
      event.stopPropagation();
    };

    handlePointerDown = (event) => {
      if (this.contains(event.target)) return;

      if (this.payments) this.payments.open = false;
      if (this.localization) this.localization.open = false;
    };
  }

  if (!customElements.get('footer-dropdowns-component')) {
    customElements.define('footer-dropdowns-component', FooterDropdownsComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["form-checkboxes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bluu-form-checkboxes')) {
    const controllers = new WeakMap();
    const owners = new WeakMap();

    function registerForm(block, form) {
      let controller = controllers.get(form);

      if (!controller) {
        const blocks = new Set();
        const abort = new AbortController();
        const validate = (event) => {
          if (event.type === 'click') {
            const button = event.target.closest('button, input');
            if (!button || button.type !== 'submit' || button.form !== form) return;
          }

          const invalid = Array.from(blocks).filter((item) => !item.validate());
          if (!invalid.length) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          invalid.sort((a, b) => a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_PRECEDING ? 1 : -1);
          invalid[0].focusQuestion();
        };

        form.addEventListener('click', validate, { capture: true, signal: abort.signal });
        form.addEventListener('submit', validate, { capture: true, signal: abort.signal });
        controller = { blocks, abort };
        controllers.set(form, controller);
      }

      controller.blocks.add(block);
      block.form = form;
    }

    class BluuFormCheckboxes extends HTMLElement {
      connectedCallback() {
        this.fieldset = this.querySelector('.form-checkboxes__fieldset');
        this.options = this.querySelector('.form-checkboxes__options');
        this.hint = this.querySelector('.form-checkboxes__hint');
        this.error = this.querySelector('.form-checkboxes__error');
        this.maxAnswers = Number(this.dataset.maxAnswers) || 0;
        this.abort = new AbortController();
        this.addEventListener('change', (event) => this.updateSource(event), { signal: this.abort.signal });
        this.documentObserver = new MutationObserver(() => this.schedule());
        this.documentObserver.observe(document.body, { childList: true, subtree: true });
        this.startedAt = Date.now();
        this.refresh();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.documentObserver?.disconnect();
        this.rootObserver?.disconnect();
        this.rootAbort?.abort();
        this.root = null;
        clearTimeout(this.retry);
        cancelAnimationFrame(this.frame);
        this.release();
      }

      schedule() {
        if (this.frame || !this.isConnected) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.refresh();
        });
      }

      release() {
        if (this.source && owners.get(this.source) === this) {
          this.source.classList.remove('bluu-survey-source');
          owners.delete(this.source);
        }

        const controller = controllers.get(this.form);
        if (controller) {
          controller.blocks.delete(this);
          if (!controller.blocks.size) {
            controller.abort.abort();
            controllers.delete(this.form);
          }
        }

        this.source = null;
        this.form = null;
        this.signature = null;
        delete this.dataset.connected;
        this.fieldset.hidden = true;
      }

      refresh() {
        clearTimeout(this.retry);
        const container = Array.from(document.querySelectorAll('[data-forms-id]')).find(
          (element) => element.dataset.formsId === `forms-root-${this.dataset.formId}`
        );
        const root = container?.querySelector('shopify-forms-embed')?.shadowRoot;

        if (root !== this.root) {
          this.release();
          this.rootObserver?.disconnect();
          this.rootAbort?.abort();
          this.root = root;

          if (root) {
            this.rootAbort = new AbortController();
            this.rootObserver = new MutationObserver(() => this.schedule());
            this.rootObserver.observe(root, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['checked', 'disabled', 'aria-invalid']
            });
            root.addEventListener('change', () => this.schedule(), { signal: this.rootAbort.signal });
            root.addEventListener('reset', () => this.schedule(), { signal: this.rootAbort.signal });
          }
        }

        const source = root && Array.from(root.querySelectorAll('fieldset[name]')).find(
          (element) => element.getAttribute('name') === this.dataset.fieldName
        );
        const inputs = source ? Array.from(source.querySelectorAll('input[type="checkbox"]')) : [];
        const form = source?.closest('form');

        if (!source || !inputs.length || !form || (owners.has(source) && owners.get(source) !== this)) {
          const keepAnswers = this.hasAttribute('data-connected') && root && !root.querySelector('form');
          this.release();
          if (keepAnswers) {
            this.dataset.connected = '';
            this.fieldset.hidden = false;
            this.fieldset.disabled = true;
            this.error.hidden = true;
          }
          if (Date.now() - this.startedAt < 30000) {
            this.retry = setTimeout(() => this.refresh(), 250);
          }
          return;
        }

        if (this.source !== source) {
          this.release();
          this.source = source;
          owners.set(source, this);
          registerForm(this, form);
        }

        const signature = JSON.stringify(inputs.map((input) => [input.value, input.getAttribute('aria-label')]));
        if (this.signature !== signature) {
          const options = inputs.map((input, index) => {
            const label = document.createElement('label');
            label.className = 'form-checkboxes__option text-medium';
            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.id = `${this.id}-option-${index}`;
            checkbox.value = input.value;
            checkbox.setAttribute('aria-describedby', `${this.hint.id} ${this.error.id}`);
            const text = document.createElement('span');
            text.textContent = input.getAttribute('aria-label') || input.value;
            label.append(checkbox, text);
            return label;
          });
          this.options.replaceChildren(...options);
          this.signature = signature;
        }

        const legend = this.querySelector('legend');
        const question = source.querySelector('legend')?.textContent || this.dataset.fieldName;
        if (legend.textContent !== question) legend.textContent = question;
        const limitReached = this.maxAnswers > 0 && inputs.filter((input) => input.checked).length >= this.maxAnswers;
        this.options.querySelectorAll('input').forEach((checkbox, index) => {
          checkbox.checked = inputs[index].checked;
          checkbox.disabled = inputs[index].disabled || source.disabled || (limitReached && !checkbox.checked);
        });

        if (!root.getElementById('bluu-survey-source-style')) {
          const style = document.createElement('style');
          style.id = 'bluu-survey-source-style';
          style.textContent = '.bluu-survey-source { display: none !important; }';
          root.append(style);
        }

        source.classList.add('bluu-survey-source');
        this.dataset.connected = '';
        this.fieldset.hidden = false;
        this.fieldset.disabled = false;
        if (!this.error.hidden) this.validate();
      }

      updateSource(event) {
        const checkbox = event.target;
        if (!checkbox.matches('.form-checkboxes__option input')) return;
        const input = Array.from(this.source?.querySelectorAll('input[type="checkbox"]') || []).find(
          (item) => item.value === checkbox.value
        );

        if (!input || !input.isConnected) {
          this.refresh();
          return;
        }

        if (
          checkbox.checked &&
          !input.checked &&
          this.maxAnswers > 0 &&
          this.source.querySelectorAll('input:checked').length >= this.maxAnswers
        ) {
          checkbox.checked = false;
          this.refresh();
          return;
        }

        if (input.checked !== checkbox.checked) input.click();
        this.schedule();
      }

      validate() {
        if (!this.source?.isConnected) {
          this.refresh();
          return true;
        }

        const selectedCount = this.source.querySelectorAll('input:checked').length;
        const tooMany = this.maxAnswers > 0 && selectedCount > this.maxAnswers;
        const valid = !tooMany && (this.dataset.required !== 'true' || selectedCount > 0);
        const message = tooMany ? this.error.dataset.maxMessage : this.error.dataset.requiredMessage;
        if (this.error.textContent !== message) this.error.textContent = message;
        this.error.hidden = valid;
        this.fieldset.setAttribute('aria-invalid', String(!valid));
        this.options.querySelectorAll('input').forEach((input) => input.setAttribute('aria-invalid', String(!valid)));
        return valid;
      }

      focusQuestion() {
        this.scrollIntoView({ behavior: 'auto', block: 'center' });
        this.options.querySelector('input:not(:disabled)')?.focus({ preventScroll: true });
      }
    }

    customElements.define('bluu-form-checkboxes', BluuFormCheckboxes);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["full-blog"] && !Shopify.designMode) return;
  try {
    class FullBlog extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.grid = this.querySelector('.full-blog__grid');
      this.cards = [...this.querySelectorAll('[data-full-blog-card]')];
      this.filterButtons = [...this.querySelectorAll('[data-full-blog-filter]')];
      this.loadMoreButton = this.querySelector('[data-full-blog-load-more]');
      this.emptyMessage = this.querySelector('.full-blog__empty');
      this.batchSize = Number.parseInt(this.dataset.batchSize, 10) || 12;
      this.visibleCount = this.batchSize;
      this.activeFilter = '';
      this.nextUrl = this.dataset.nextUrl || '';
      this.sectionId = this.dataset.sectionId || '';
      this.blockId = this.dataset.blockId || '';
      this.isLoading = false;

      this.prepareCards(this.cards);
      this.sortCards();
      this.grid.append(...this.cards);

      this.filterButtons.forEach((button) => {
        button.addEventListener('click', async () => {
          if (button.dataset.fullBlogFilter === this.activeFilter || this.isLoading) return;

          this.activeFilter = button.dataset.fullBlogFilter;
          this.visibleCount = this.batchSize;
          this.filterButtons.forEach((filterButton) => {
            filterButton.setAttribute('aria-pressed', String(filterButton === button));
          });

          this.setLoading(true);
          try {
            await this.loadUntilEnough();
          } finally {
            this.setLoading(false);
          }
          this.withTransition(() => this.update());
        });
      });

      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', async () => {
          if (this.isLoading) return;

          this.visibleCount += this.batchSize;
          this.setLoading(true);
          try {
            await this.loadUntilEnough();
          } finally {
            this.setLoading(false);
          }
          this.withTransition(() => this.update());
        });
      }

      this.update();
    }

    prepareCards(cards) {
      cards.forEach((card) => {
        try {
          card.fullBlogTags = JSON.parse(card.dataset.articleTags || '[]');
        } catch {
          card.fullBlogTags = [];
        }
      });
    }

    sortCards() {
      this.cards.sort((firstCard, secondCard) => {
        return Number(secondCard.dataset.publishedAt) - Number(firstCard.dataset.publishedAt);
      });
    }

    getMatchingCards() {
      return this.cards.filter((card) => {
        return this.activeFilter === '' || card.fullBlogTags.includes(this.activeFilter);
      });
    }

    async loadUntilEnough() {
      while (this.nextUrl && this.getMatchingCards().length < this.visibleCount) {
        const requestedUrl = this.nextUrl;

        await this.loadNextPage();

        if (this.nextUrl === requestedUrl) {
          this.nextUrl = '';
        }
      }
    }

    async loadNextPage() {
      if (!this.nextUrl || !this.sectionId || !this.blockId) return;

      const requestUrl = new URL(this.nextUrl, window.location.href);
      requestUrl.searchParams.set('section_id', this.sectionId);

      try {
        const response = await fetch(requestUrl.toString());

        if (!response.ok) {
          this.nextUrl = '';
          return;
        }

        const html = await response.text();
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const renderedBlock = parsedDocument.querySelector(`full-blog[data-block-id="${this.blockId}"]`);

        if (!renderedBlock) {
          this.nextUrl = '';
          return;
        }

        const existingUrls = new Set(this.cards.map((card) => card.getAttribute('href')));
        const newCards = [...renderedBlock.querySelectorAll('[data-full-blog-card]')].filter((card) => {
          return !existingUrls.has(card.getAttribute('href'));
        });

        this.nextUrl = renderedBlock.dataset.nextUrl || '';
        this.prepareCards(newCards);
        newCards.forEach((card) => {
          card.hidden = true;
        });
        this.cards.push(...newCards);
        this.sortCards();
        this.grid.append(...this.cards);
      } catch {
        this.nextUrl = '';
      }
    }

    setLoading(isLoading) {
      this.isLoading = isLoading;
      this.setAttribute('aria-busy', String(isLoading));

      if (this.loadMoreButton) {
        this.loadMoreButton.disabled = isLoading;
      }
    }

    withTransition(update) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        update();
        return;
      }

      if (document.startViewTransition) {
        document.startViewTransition(update);
        return;
      }

      update();
    }

    update() {
      const matchingCards = this.getMatchingCards();

      this.cards.forEach((card) => {
        card.hidden = true;
      });

      matchingCards.forEach((card, index) => {
        card.hidden = index >= this.visibleCount;
      });

      if (this.emptyMessage) {
        this.emptyMessage.hidden = matchingCards.length > 0;
      }

      if (this.loadMoreButton) {
        this.loadMoreButton.hidden = matchingCards.length <= this.visibleCount && !this.nextUrl;
      }
    }
  }

  if (!customElements.get('full-blog')) {
    customElements.define('full-blog', FullBlog);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.themeImageBlockSyncInitialized === true) return;
    window.themeImageBlockSyncInitialized = true;

    const BLOCK_SELECTOR = '[data-image-sync-block]';
    const SOURCE_SELECTOR = '[data-image-sync-source="true"]';
    const TARGET_SELECTOR = '[data-image-sync-target="true"]';
    const MEDIA_SELECTOR = '[data-image-sync-media]';
    const TARGET_CONTENT_SELECTOR = '[data-image-sync-placeholder], [data-image-sync-clone="true"]';

    const getSectionRoot = (element) => {
      return element.closest('[id^="shopify-section-"]') || element.closest('.shopify-section') || document;
    };

    const getNearestSource = (target, sectionRoot) => {
      const blocks = Array.from(sectionRoot.querySelectorAll(BLOCK_SELECTOR));
      const targetIndex = blocks.indexOf(target);

      return blocks
        .filter((block) => block !== target && block.matches(SOURCE_SELECTOR) && block.querySelector(MEDIA_SELECTOR))
        .sort((a, b) => {
          const aIndex = blocks.indexOf(a);
          const bIndex = blocks.indexOf(b);
          return Math.abs(aIndex - targetIndex) - Math.abs(bIndex - targetIndex);
        })[0];
    };

    const applyTargetImageSettings = (clone, target) => {
      const imageStyle = target.dataset.imageSyncStyle || '';
      const customClasses = (target.dataset.imageSyncCustomClass || '').split(/\s+/).filter(Boolean);

      clone.classList.remove('image-block__media--hover');
      clone.querySelectorAll('.image-block__image--hover').forEach((image) => image.remove());

      clone.querySelectorAll('.image-block__image').forEach((image) => {
        image.removeAttribute('id');
        if (imageStyle) image.setAttribute('style', imageStyle);
        customClasses.forEach((className) => image.classList.add(className));
      });
    };

    const syncTarget = (target) => {
      if (!(target instanceof HTMLElement)) return;

      const sectionRoot = getSectionRoot(target);
      const source = getNearestSource(target, sectionRoot);
      const sourceMedia = source?.querySelector(MEDIA_SELECTOR);
      const targetContent = target.querySelector(TARGET_CONTENT_SELECTOR);

      if (!(sourceMedia instanceof HTMLElement) || !(targetContent instanceof HTMLElement)) return;

      const clone = sourceMedia.cloneNode(true);
      clone.setAttribute('data-image-sync-clone', 'true');
      applyTargetImageSettings(clone, target);
      targetContent.replaceWith(clone);
    };

    const syncAll = (root = document) => {
      const targets =
        root instanceof Element && root.matches(TARGET_SELECTOR)
          ? [root]
          : Array.from(root.querySelectorAll(TARGET_SELECTOR));

      targets.forEach(syncTarget);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncAll());
    } else {
      syncAll();
    }

    document.addEventListener('shopify:section:load', (event) => syncAll(event.target));
    document.addEventListener('shopify:block:select', (event) => syncAll(getSectionRoot(event.target)));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-cookie-preferences-trigger]');
    if (!trigger) return;

    event.preventDefault();

    if (typeof window.privacyBanner?.showPreferences !== 'function') return;

    window.privacyBanner.showPreferences().catch(() => {});
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price-per-piece"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('price-per-piece')) {
    customElements.define(
      'price-per-piece',
      class PricePerPiece extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section, dialog');
          this.handleProductSelect = (event) => this.updateFromProductSelect(event);
          this.section?.addEventListener('shopify:product:select', this.handleProductSelect);
        }

        disconnectedCallback() {
          this.section?.removeEventListener('shopify:product:select', this.handleProductSelect);
        }

        updateFromProductSelect(event) {
          if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

          event.promise
            .then(({ detail }) => {
              if (!detail?.html) return;
              if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;

              const blockId = CSS.escape(this.dataset.blockId || '');
              const nextBlock = detail.html.querySelector(`price-per-piece[data-block-id="${blockId}"]`);
              if (!nextBlock) return;

              this.dataset.productId = nextBlock.dataset.productId || this.dataset.productId;
              this.hidden = nextBlock.hidden;

              const message = this.querySelector('[data-price-per-piece-message]');
              const nextMessage = nextBlock.querySelector('[data-price-per-piece-message]');
              if (message && nextMessage) message.textContent = nextMessage.textContent;
            })
            .catch((error) => {
              if (error?.name !== 'AbortError') console.warn('[price-per-piece] Event promise rejected:', error);
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-comparison-table"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-comparison-table')) {
    customElements.define(
      'variant-comparison-table',
      class VariantComparisonTable extends HTMLElement {
        connectedCallback() {
          this.eventTarget = this.closest('.shopify-section, dialog');
          this.eventTarget?.addEventListener('shopify:product:select', this.handleProductSelect);
        }

        disconnectedCallback() {
          this.eventTarget?.removeEventListener('shopify:product:select', this.handleProductSelect);
        }

        handleProductSelect = (event) => {
          if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

          event.promise
            .then(({ detail }) => {
              if (!detail?.html || !this.isConnected) return;

              if (
                !detail.newProduct &&
                detail.productId &&
                this.dataset.productId &&
                detail.productId !== this.dataset.productId
              ) {
                return;
              }

              const newComparisonTable = Array.from(
                detail.html.querySelectorAll('variant-comparison-table[data-variant-comparison-table]')
              ).find((element) => element.dataset.blockId === this.dataset.blockId);

              if (!newComparisonTable) return;

              this.replaceWith(newComparisonTable.cloneNode(true));
            })
            .catch((error) => {
              if (error?.name !== 'AbortError') console.warn('[variant-comparison-table] Event promise rejected:', error);
            });
        };
      }
    );
  }

  if (!customElements.get('product-comparison-table')) {
    customElements.define(
      'product-comparison-table',
      class ProductComparisonTable extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.scroller = this.querySelector('[data-comparison-table-scroller]');
          this.table = this.querySelector('.product-comparison-table__table');
          this.pagination = this.querySelector('[data-comparison-table-pagination]');
          this.progress = this.querySelector('[data-comparison-table-progress]');
          this.animationFrame = 0;
          this.handleScroll = this.requestUpdate.bind(this);

          this.scroller?.addEventListener('scroll', this.handleScroll, { passive: true });

          if (this.scroller) {
            this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
            this.resizeObserver.observe(this.scroller);
            if (this.table) this.resizeObserver.observe(this.table);
          }

          this.update();
        }

        disconnectedCallback() {
          this.scroller?.removeEventListener('scroll', this.handleScroll);
          this.resizeObserver?.disconnect();
          window.cancelAnimationFrame(this.animationFrame);
          this.initialized = false;
        }

        requestUpdate() {
          if (this.animationFrame) return;

          this.animationFrame = window.requestAnimationFrame(() => {
            this.animationFrame = 0;
            this.update();
          });
        }

        update() {
          if (!this.scroller || !this.pagination || !this.progress) return;

          const maxScroll = Math.max(this.scroller.scrollWidth - this.scroller.clientWidth, 0);
          const hasOverflow = maxScroll > 1;
          const scrollRatio = hasOverflow
            ? Math.min(Math.max(Math.abs(this.scroller.scrollLeft) / maxScroll, 0), 1)
            : 0;
          const visibleRatio = this.scroller.scrollWidth > 0
            ? Math.min(this.scroller.clientWidth / this.scroller.scrollWidth, 1)
            : 1;
          const thumbWidth = Math.max(visibleRatio * 100, 18);
          const travel = Math.max(100 - thumbWidth, 0);

          this.pagination.hidden = !hasOverflow;
          this.progress.style.width = `${thumbWidth}%`;
          this.progress.style.left = `${scrollRatio * travel}%`;
          this.progress.style.transform = 'none';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-info-accordion"] && !Shopify.designMode) return;
  try {
    class ProductInfoAccordion extends HTMLElement {
    alignmentFrame = null;
    alignmentStartedAt = 0;
    alignmentStartTop = 0;
    alignmentDuration = 600;
    alignmentOpening = true;
    alignmentScrollContainer = null;
    alignmentScrollBehavior = '';
    alignmentHeader = null;
    alignmentHeaderInset = 16;
    alignmentHeaderReleaseFrame = null;
    alignmentPendingHeader = null;
    alignmentSummaryLocks = [];
    mobileAlignmentSummary = null;
    mobileAlignmentTargetTop = 0;
    pendingAlignmentRow = null;
    pendingAlignmentStartTop = null;
    pendingAlignmentSummaryTop = null;

    connectedCallback() {
      this.eventTarget = this.closest('.shopify-section, dialog');
      this.eventTarget?.addEventListener('shopify:product:select', this.handleProductSelect);
      this.addEventListener('pointerdown', this.captureAlignmentStart, true);
      this.addEventListener('keydown', this.captureAlignmentStart, true);
      this.addEventListener('click', this.handleRowClick);
    }

    disconnectedCallback() {
      this.eventTarget?.removeEventListener('shopify:product:select', this.handleProductSelect);
      this.removeEventListener('pointerdown', this.captureAlignmentStart, true);
      this.removeEventListener('keydown', this.captureAlignmentStart, true);
      this.removeEventListener('click', this.handleRowClick);

      this.resetAlignment();
    }

    captureAlignmentStart = (event) => {
      if (!(event.target instanceof Element)) return;
      if (event instanceof KeyboardEvent && event.key !== 'Enter' && event.key !== ' ') return;

      const summary = event.target.closest('accordion-custom[data-product-info-row] > details > summary');
      const row = summary?.closest('accordion-custom[data-product-info-row]');

      if (!(row instanceof HTMLElement) || !this.contains(row)) return;
      if (!this.closest('.product-details.sticky-content--desktop') || this.closest('dialog')) return;

      this.pendingAlignmentRow = row;
      this.pendingAlignmentSummaryTop = summary.getBoundingClientRect().top;
      this.pendingAlignmentStartTop = null;

      if (!window.matchMedia('(min-width: 750px)').matches) return;

      this.pendingAlignmentStartTop = this.getBoundingClientRect().top;
    };

    handleRowClick = (event) => {
      if (!(event.target instanceof Element)) return;

      const summary = event.target.closest('accordion-custom[data-product-info-row] > details > summary');
      const row = summary?.closest('accordion-custom[data-product-info-row]');

      if (!(row instanceof HTMLElement) || !this.contains(row)) return;
      if (!this.closest('.product-details.sticky-content--desktop') || this.closest('dialog')) return;

      const startTop = this.pendingAlignmentRow === row ? this.pendingAlignmentStartTop : null;
      const summaryStartTop = this.pendingAlignmentRow === row ? this.pendingAlignmentSummaryTop : null;
      this.pendingAlignmentRow = null;
      this.pendingAlignmentStartTop = null;
      this.pendingAlignmentSummaryTop = null;

      if (!window.matchMedia('(min-width: 750px)').matches) {
        this.handleMobileRowClick(row, summary, summaryStartTop);
        return;
      }

      this.resetAlignment(true);

      this.alignmentStartedAt = performance.now();
      this.alignmentStartTop = startTop ?? this.getBoundingClientRect().top;
      this.alignmentDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 600;
      this.alignmentOpening = row.classList.contains('accordion-custom--expanded');

      const header = document.querySelector('#header-component');

      if (header instanceof HTMLElement && header.hasAttribute('sticky')) {
        const headerRect = header.getBoundingClientRect();
        const headerIsVisible = header.dataset.stickyState === 'active' && headerRect.bottom > 0;

        this.alignmentHeader = header;
        this.alignmentHeaderInset = headerIsVisible ? headerRect.bottom + 16 : 16;
        header.lockScrollState?.();
      }

      const alignmentDistance = this.alignmentStartTop - this.alignmentHeaderInset;
      const alignmentDeadZone = summary.getBoundingClientRect().height / 2;
      const rows = Array.from(this.querySelectorAll('accordion-custom[data-product-info-row]'));
      const rowIndex = rows.indexOf(row);
      let openPredecessorIndex = -1;

      for (let index = 0; index < rowIndex; index += 1) {
        if (rows[index].querySelector('details[open]')) {
          openPredecessorIndex = index;
        }
      }

      if (Math.abs(alignmentDistance) <= alignmentDeadZone) {
        this.alignmentHeaderInset = this.alignmentStartTop;
        const lastStableRowIndex = openPredecessorIndex === -1 ? rowIndex : openPredecessorIndex;

        this.lockAlignmentSummaries(rows.slice(0, lastStableRowIndex + 1));
      }

      this.alignBelowHeader();
    };

    handleMobileRowClick(row, summary, summaryStartTop) {
      this.resetAlignment();

      if (summaryStartTop === null || !row.classList.contains('accordion-custom--expanded')) return;

      const rows = Array.from(this.querySelectorAll('accordion-custom[data-product-info-row]'));
      const rowIndex = rows.indexOf(row);
      const precedingRowIsClosing = rows.slice(0, rowIndex).some((precedingRow) => {
        return (
          precedingRow.querySelector(':scope > details[open]') &&
          !precedingRow.classList.contains('accordion-custom--expanded')
        );
      });

      if (!precedingRowIsClosing) return;

      this.alignmentStartedAt = performance.now();
      this.alignmentDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 600;
      this.mobileAlignmentSummary = summary;
      this.mobileAlignmentTargetTop = summaryStartTop;
      this.alignMobileSummary();
    }

    alignMobileSummary() {
      this.alignmentFrame = window.requestAnimationFrame((timestamp) => {
        const scrollContainer = document.scrollingElement;

        if (!(scrollContainer instanceof HTMLElement) || !(this.mobileAlignmentSummary instanceof HTMLElement)) {
          this.resetAlignment();
          return;
        }

        if (this.alignmentScrollContainer !== scrollContainer) {
          this.alignmentScrollContainer = scrollContainer;
          this.alignmentScrollBehavior = scrollContainer.style.scrollBehavior;
          scrollContainer.style.scrollBehavior = 'auto';
        }

        const pixelRatio = window.devicePixelRatio || 1;
        const currentPixel = Math.round(this.mobileAlignmentSummary.getBoundingClientRect().top * pixelRatio);
        const targetPixel = Math.round(this.mobileAlignmentTargetTop * pixelRatio);
        const scrollCorrection = (currentPixel - targetPixel) / pixelRatio;

        if (scrollCorrection !== 0) {
          scrollContainer.scrollTop = Math.max(0, scrollContainer.scrollTop + scrollCorrection);
        }

        const elapsed = timestamp - this.alignmentStartedAt;
        const settleDuration = this.alignmentDuration === 0 ? 0 : 180;

        if (elapsed < this.alignmentDuration + settleDuration) {
          this.alignMobileSummary();
        } else {
          this.resetAlignment();
        }
      });
    }

    lockAlignmentSummaries(rows) {
      const locks = rows
        .map((row) => {
          const summary = row.querySelector(':scope > details > summary');

          if (!(summary instanceof HTMLElement)) return null;

          const rowRect = row.getBoundingClientRect();
          const summaryRect = summary.getBoundingClientRect();

          return {
            row,
            summary,
            top: summaryRect.top,
            rowOffset: summaryRect.top - rowRect.top,
            style: summary.getAttribute('style'),
          };
        })
        .filter(Boolean);

      for (const lock of locks) {
        Object.assign(lock.summary.style, {
          position: 'relative',
          zIndex: '3',
          translate: '0 0',
          willChange: 'translate',
        });
      }

      this.alignmentSummaryLocks = locks;
    }

    updateAlignmentSummaries() {
      for (const lock of this.alignmentSummaryLocks) {
        const naturalTop = lock.row.getBoundingClientRect().top + lock.rowOffset;

        lock.summary.style.translate = `0 ${lock.top - naturalTop}px`;
      }
    }

    alignBelowHeader() {
      this.alignmentFrame = window.requestAnimationFrame((timestamp) => {
        const usePageWrapper = window.matchMedia('(min-width: 990px)').matches;
        const pageWrapper = usePageWrapper ? document.querySelector('.page-wrapper') : null;
        const scrollContainer = pageWrapper instanceof HTMLElement ? pageWrapper : document.scrollingElement;

        if (!(scrollContainer instanceof HTMLElement)) {
          this.resetAlignment();
          return;
        }

        if (this.alignmentScrollContainer !== scrollContainer) {
          this.alignmentScrollContainer = scrollContainer;
          this.alignmentScrollBehavior = scrollContainer.style.scrollBehavior;
          scrollContainer.style.scrollBehavior = 'auto';
        }

        const elapsed = timestamp - this.alignmentStartedAt;
        const progress = this.alignmentDuration === 0 ? 1 : Math.min(elapsed / this.alignmentDuration, 1);
        const easedProgress = progress * progress * (3 - 2 * progress);
        const desiredTop = this.alignmentOpening
          ? this.alignmentStartTop + (this.alignmentHeaderInset - this.alignmentStartTop) * easedProgress
          : this.alignmentStartTop;
        const pixelRatio = window.devicePixelRatio || 1;
        const currentPixel = Math.round(this.getBoundingClientRect().top * pixelRatio);
        const desiredPixel = Math.round(desiredTop * pixelRatio);
        const scrollCorrection = (currentPixel - desiredPixel) / pixelRatio;

        if (scrollCorrection !== 0) {
          scrollContainer.scrollTop = Math.max(0, scrollContainer.scrollTop + scrollCorrection);
        }

        this.updateAlignmentSummaries();

        const shouldSettle = this.alignmentDuration > 0 && elapsed < this.alignmentDuration + 180;

        if (progress < 1 || shouldSettle) {
          this.alignBelowHeader();
        } else {
          this.resetAlignment();
        }
      });
    }

    resetAlignment(keepHeaderLocked = false) {
      if (this.alignmentFrame !== null) window.cancelAnimationFrame(this.alignmentFrame);
      if (this.alignmentHeaderReleaseFrame !== null) {
        window.cancelAnimationFrame(this.alignmentHeaderReleaseFrame);

        if (!keepHeaderLocked) {
          this.alignmentPendingHeader?.releaseScrollState?.();
        }

        this.alignmentHeaderReleaseFrame = null;
        this.alignmentPendingHeader = null;
      }
      if (this.alignmentScrollContainer !== null) {
        this.alignmentScrollContainer.style.scrollBehavior = this.alignmentScrollBehavior;
      }
      if (this.alignmentHeader !== null && !keepHeaderLocked) {
        this.alignmentPendingHeader = this.alignmentHeader;
        this.alignmentHeaderReleaseFrame = window.requestAnimationFrame(() => {
          this.alignmentPendingHeader?.releaseScrollState?.();
          this.alignmentHeaderReleaseFrame = null;
          this.alignmentPendingHeader = null;
        });
      }
      for (const lock of this.alignmentSummaryLocks) {
        if (lock.style === null) {
          lock.summary.removeAttribute('style');
        } else {
          lock.summary.setAttribute('style', lock.style);
        }
      }

      this.alignmentFrame = null;
      this.alignmentStartedAt = 0;
      this.alignmentStartTop = 0;
      this.alignmentOpening = true;
      this.alignmentScrollContainer = null;
      this.alignmentScrollBehavior = '';
      this.alignmentHeader = null;
      this.alignmentHeaderInset = 16;
      this.alignmentSummaryLocks = [];
      this.mobileAlignmentSummary = null;
      this.mobileAlignmentTargetTop = 0;
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newAccordion = Array.from(detail.html.querySelectorAll('product-info-accordion')).find(
            (element) => element.dataset.blockId === this.dataset.blockId
          );

          if (!newAccordion) return;

          const openRowIds = new Set(
            Array.from(this.querySelectorAll('accordion-custom[data-product-info-row]'))
              .filter((row) => row.querySelector('details[open]'))
              .map((row) => row.dataset.blockId)
          );
          const replacement = newAccordion.cloneNode(true);

          for (const row of replacement.querySelectorAll('accordion-custom[data-product-info-row]')) {
            if (openRowIds.has(row.dataset.blockId)) {
              row.querySelector('details')?.setAttribute('open', '');
            }
          }

          this.replaceWith(replacement);
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[product-info-accordion] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('product-info-accordion')) {
    customElements.define('product-info-accordion', ProductInfoAccordion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-variant-feature"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const selector = event.target.closest('[data-product-variant-feature-selector]');
    if (!selector) return;

    const feature = selector.closest('.product-variant-feature');
    const selectedOption = selector.selectedOptions[0];
    const variantInput = feature?.querySelector('input[ref="variantId"]');

    if (variantInput) {
      variantInput.value = selector.value;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const variantTitle = feature?.querySelector('.product-variant-feature__variant');
    if (variantTitle && selectedOption?.dataset.title) {
      variantTitle.textContent = selectedOption.dataset.title;
    }

    const currentPrice = feature?.querySelector('[data-product-variant-feature-current-price]');
    if (currentPrice && selectedOption?.dataset.price) {
      currentPrice.textContent = selectedOption.dataset.price;
    }

    const comparePrice = feature?.querySelector('[data-product-variant-feature-compare-price]');
    if (comparePrice) {
      comparePrice.textContent = selectedOption?.dataset.comparePrice || '';
      comparePrice.hidden = !selectedOption?.dataset.comparePrice;
    }

    const image = feature?.querySelector('.product-variant-feature__image');
    if (image && selectedOption?.dataset.image) {
      image.removeAttribute('srcset');
      image.src = selectedOption.dataset.image;
    }

    const mediaLink = feature?.querySelector('.product-variant-feature__media a');
    if (mediaLink && selectedOption?.dataset.url) {
      mediaLink.href = selectedOption.dataset.url;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["retailer-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('retailer-slider-preloader')) {
    class RetailerSliderPreloader extends HTMLElement {
      #observer;

      connectedCallback() {
        this.addEventListener('slideshow:select', this.#handleSlideSelect);

        this.#observer = new IntersectionObserver(
          ([entry]) => {
            if (!entry?.isIntersecting) return;

            this.#preloadFrom(0);
            this.#observer?.disconnect();
          },
          { rootMargin: '1600px 0px' }
        );

        this.#observer.observe(this);
      }

      disconnectedCallback() {
        this.removeEventListener('slideshow:select', this.#handleSlideSelect);
        this.#observer?.disconnect();
      }

      #handleSlideSelect = (event) => {
        this.#preloadFrom(event.detail.index + 1);
      };

      #preloadFrom(startIndex) {
        const images = Array.from(this.querySelectorAll('.retailer-slider__image')).slice(startIndex, startIndex + 10);

        for (const image of images) {
          if (image.loading !== 'lazy') continue;

          image.loading = 'eager';
          image.decode().catch(() => {});
        }
      }
    }

    customElements.define('retailer-slider-preloader', RetailerSliderPreloader);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["slideshow"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobileViewport = window.matchMedia('(max-width: 749px)');
    const lockedClass = 'landing-hero-height-locked';
    const lockedHeightProperty = '--landing-hero-locked-height';
    let lastViewportWidth = window.innerWidth;
    let resizeTimeout;

    const lockLandingHeroHeight = () => {
      document.querySelectorAll('.landing-hero').forEach((hero) => {
        const section = hero.closest('.section-wrapper')?.querySelector(':scope > .section');
        if (!(section instanceof HTMLElement)) return;

        section.classList.remove(lockedClass);
        section.style.removeProperty(lockedHeightProperty);

        if (!mobileViewport.matches) return;
        if (hero.classList.contains('landing-hero--content-fit')) return;

        const renderedHeight = Math.round(section.getBoundingClientRect().height);
        if (renderedHeight <= 0) return;

        section.style.setProperty(lockedHeightProperty, `${renderedHeight}px`);
        section.classList.add(lockedClass);
      });
    };

    const handleViewportResize = () => {
      const currentViewportWidth = window.innerWidth;
      const widthChanged = Math.abs(currentViewportWidth - lastViewportWidth) > 1;

      if (!widthChanged && resizeTimeout === undefined) return;
      if (widthChanged) lastViewportWidth = currentViewportWidth;

      window.clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(() => {
        resizeTimeout = undefined;
        lockLandingHeroHeight();
      }, 150);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', lockLandingHeroHeight, { once: true });
    } else {
      lockLandingHeroHeight();
    }

    window.addEventListener('resize', handleViewportResize, { passive: true });
    document.addEventListener('shopify:section:load', lockLandingHeroHeight);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-button"] && !Shopify.designMode) return;
  try {
    class VariantButton extends HTMLElement {
    connectedCallback() {
      this.eventTarget = this.closest('.shopify-section, dialog');
      this.eventTarget?.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      this.eventTarget?.removeEventListener('shopify:product:select', this.handleProductSelect);
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newVariantButton = Array.from(detail.html.querySelectorAll('variant-button[data-variant-button]')).find(
            (element) => element.dataset.blockId === this.dataset.blockId
          );

          if (!newVariantButton) return;

          this.replaceWith(newVariantButton.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[variant-button] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('variant-button')) {
    customElements.define('variant-button', VariantButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-image"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.themeImageBlockSyncInitialized === true) return;
    window.themeImageBlockSyncInitialized = true;

    const BLOCK_SELECTOR = '[data-image-sync-block]';
    const SOURCE_SELECTOR = '[data-image-sync-source="true"]';
    const TARGET_SELECTOR = '[data-image-sync-target="true"]';
    const MEDIA_SELECTOR = '[data-image-sync-media]';
    const TARGET_CONTENT_SELECTOR = '[data-image-sync-placeholder], [data-image-sync-clone="true"]';

    const getSectionRoot = (element) => {
      return element.closest('[id^="shopify-section-"]') || element.closest('.shopify-section') || document;
    };

    const getNearestSource = (target, sectionRoot) => {
      const blocks = Array.from(sectionRoot.querySelectorAll(BLOCK_SELECTOR));
      const targetIndex = blocks.indexOf(target);

      return blocks
        .filter((block) => block !== target && block.matches(SOURCE_SELECTOR) && block.querySelector(MEDIA_SELECTOR))
        .sort((a, b) => {
          const aIndex = blocks.indexOf(a);
          const bIndex = blocks.indexOf(b);
          return Math.abs(aIndex - targetIndex) - Math.abs(bIndex - targetIndex);
        })[0];
    };

    const applyTargetImageSettings = (clone, target) => {
      const imageStyle = target.dataset.imageSyncStyle || '';
      const customClasses = (target.dataset.imageSyncCustomClass || '').split(/\s+/).filter(Boolean);

      clone.classList.remove('image-block__media--hover');
      clone.querySelectorAll('.image-block__image--hover').forEach((image) => image.remove());

      clone.querySelectorAll('.image-block__image').forEach((image) => {
        image.removeAttribute('id');
        if (imageStyle) image.setAttribute('style', imageStyle);
        customClasses.forEach((className) => image.classList.add(className));
      });
    };

    const syncTarget = (target) => {
      if (!(target instanceof HTMLElement)) return;

      const sectionRoot = getSectionRoot(target);
      const source = getNearestSource(target, sectionRoot);
      const sourceMedia = source?.querySelector(MEDIA_SELECTOR);
      const targetContent = target.querySelector(TARGET_CONTENT_SELECTOR);

      if (!(sourceMedia instanceof HTMLElement) || !(targetContent instanceof HTMLElement)) return;

      const clone = sourceMedia.cloneNode(true);
      clone.setAttribute('data-image-sync-clone', 'true');
      applyTargetImageSettings(clone, target);
      targetContent.replaceWith(clone);
    };

    const syncAll = (root = document) => {
      const targets =
        root instanceof Element && root.matches(TARGET_SELECTOR)
          ? [root]
          : Array.from(root.querySelectorAll(TARGET_SELECTOR));

      targets.forEach(syncTarget);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncAll());
    } else {
      syncAll();
    }

    document.addEventListener('shopify:section:load', (event) => syncAll(event.target));
    document.addEventListener('shopify:block:select', (event) => syncAll(getSectionRoot(event.target)));
  })();

  class VariantImage extends HTMLElement {
    connectedCallback() {
      this.eventTarget = this.closest('.shopify-section, dialog');
      this.eventTarget?.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      this.eventTarget?.removeEventListener('shopify:product:select', this.handleProductSelect);
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newVariantImage = Array.from(detail.html.querySelectorAll('variant-image[data-variant-image]')).find(
            (element) => element.dataset.blockId === this.dataset.blockId
          );

          if (!newVariantImage) return;

          this.replaceWith(newVariantImage.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[variant-image] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('variant-image')) {
    customElements.define('variant-image', VariantImage);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-text"] && !Shopify.designMode) return;
  try {
    class VariantText extends HTMLElement {
    connectedCallback() {
      this.eventTarget = this.closest('.shopify-section, dialog');
      this.eventTarget?.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      this.eventTarget?.removeEventListener('shopify:product:select', this.handleProductSelect);
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

      event.promise
        .then(({ detail }) => {
          if (!detail?.html || !this.isConnected) return;

          if (
            !detail.newProduct &&
            detail.productId &&
            this.dataset.productId &&
            detail.productId !== this.dataset.productId
          ) {
            return;
          }

          const newVariantText = Array.from(detail.html.querySelectorAll('variant-text[data-variant-text]')).find(
            (element) => element.dataset.blockId === this.dataset.blockId
          );

          if (!newVariantText) return;

          this.replaceWith(newVariantText.cloneNode(true));
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[variant-text] Event promise rejected:', error);
        });
    };
  }

  if (!customElements.get('variant-text')) {
    customElements.define('variant-text', VariantText);
  }
  } catch(e) { console.error(e); }
})();

})();
